import React from 'react'

import Companies from './companies.json'

const ExperienceList = () => {
  const technologiesUsedLength = (strLength) => {
    return strLength > 0;
  }

  return (
    <ul className="timeline">
      {Companies.map((company, companyIdx) => {
        const JobDetails = company.roles.map((role, roleIdx) => {
          return (
            <span key={roleIdx}>
              <h4>{role.roleName}</h4>

              {technologiesUsedLength(role.technologiesUsed.length) ? (
                <h5>
                  Technologies: (<strong>{role.technologiesUsed}</strong>)
                </h5>
              ) : (
                <h5>
                  <strong>{role.ref}</strong>)
                </h5>
              )}

              <ul>
                {role.jobDescription.map((item, descriptionIdx) => {
                  return <li key={descriptionIdx}>{item}</li>
                })}
              </ul>
            </span>
          )
        })

        return (
          <li key={companyIdx} className="timeline-event">
            <label className="timeline-event-icon"></label>
            <div className="timeline-event-copy">
              <p className="timeline-event-thumbnail">{`${company.startDate} - ${company.endDate}`}</p>
              <h3>{company.companyName}</h3>
              {JobDetails}
            </div>
          </li>
        )
      })}
    </ul>
  )
}

export default ExperienceList
